import React from 'react'
import {Col, Row, Table} from 'antd'

export const SuborderCommonPresentation = (props: {data: any}) => {
  const {data} = props
  console.log("SuborderCommonPresentation",data)

  return (
    <Row>
      <Col span={6} push={18}>
        <img src={data?.product?.images && JSON.parse(data?.product?.images.split('---')[0]).url} style={{width: '100%', padding: '1rem'}}/>
      </Col>
      <Col span={18} pull={6}>
        <p>您将进行这单/You are going to do this order</p>
        <Table
          columns={[
            {title: '代码/Code', dataIndex: 'productCode', key: 'productCode', width: 150 },            
            {title: '产品/Product', dataIndex: 'product', key: 'product', width: 300 },
            {title: '原订单数量/Order Quantity', dataIndex: 'originalQuantity', key: 'originalQuantity', width: 150 },
            {title: '已生产数量/Produced Quantity', dataIndex: 'quantity', key: 'quantity', width: 150 },
            // {title: '接受数量/Received Quantity', dataIndex: 'quantity', key: 'quantity' },            
            {title: '备注/Comment', dataIndex: 'comment', key: 'comment', width: 150 },
          ]}
          dataSource={[
            // {key: '1', product: data?.product?.productName, productCode: data?.product?.productCode, originalQuantity: data?.orginalQuantity,  quantity:  data?.orginalQuantity - data?.receivedQuantity, comment: data?.comments}
            {key: '1', product: data?.product?.productName, productCode: data?.product?.productCode, originalQuantity: data?.orginalQuantity,  quantity: data?.productionQuantity || 0, comment: data?.comments}
          ]}
          pagination={false}
        />
      </Col>
    </Row>
  )
}
